
<template>
    <div>
        <mars-view :class="['law-search-container', isSearching || isScrollToBottom ? 'searching' : 'searched', isSwan ? 'swan-container' : 'h5-container']"><mars-view v-if="!isSearching"><mars-view class="qa-srearch-card-top" :style="{'height': entireHeight + 'px'}"></mars-view><mars-view :class="!isScrollToBottom ? entireHeight === 44 ? 'qa-srearch-card-bg-h5' : 'qa-srearch-card-bg' : ''"></mars-view></mars-view><top-bar :title="isSearching ? '查询' : '查询结果'" text-color="#333" :no-show-home="true" :no-blank="!isSearching" bg-color="custom"></top-bar><mars-view class="input-box"><mars-view class="search-icon"></mars-view><mars-input class="input" placeholder="搜索关键词" placeholder-class="placeholder" :maxlength="200" :value="inputVal" :adjust-position="false" placeholder-style="color:#999;" @input="handleInput"></mars-input><mars-view class="clear-box" @click.native="clearInput"></mars-view><mars-view class="split"></mars-view><mars-view class="search-btn" @click.native="clickSearchBtn">搜索</mars-view></mars-view><mars-view v-if="!isSearching" class="tab-box"><mars-view v-for="(type, index) in tabs" :key="index" :class="['tab-item', tabSelectedIdx === index ? 'tab-active' : '']" @click.native="selectTab(index)">
            {{ type }}
        </mars-view></mars-view><mars-view v-if="!isSearching" class="main-content-box"><mars-scroll-view class="qa-scroll-box" scroll-y @scrolltolower="fetchMore" @scroll="scroll"><mars-view class="search-result-num">
                为您找到以下 <span class="blue">{{ total }}</span> 个{{ tabs[tabSelectedIdx] }}结果：
            </mars-view><mars-view class="search-list-box"><mars-view v-for="(item, index) in searchResult" :key="index"><law-regulation-item v-if="tabSelectedIdx === 0" :law-info="item"></law-regulation-item><search-answer-item v-if="tabSelectedIdx === 1" :answer-info="item"></search-answer-item></mars-view></mars-view></mars-scroll-view></mars-view><mars-view v-if="isSearching" class="search-tip-list-box"><mars-view v-for="(tip, idx) in tips" :key="idx" class="tip-box" @click.native="clickSimilarQuestion(tip)"><mars-view class="search-icon"></mars-view><mars-rich-text :nodes="tip" class="tip-content"></mars-rich-text></mars-view></mars-view></mars-view>
    </div>
</template>

<script>
/**
 * @file 法律法规
 */
/* globals getApp, Page, swan */
import log from '../../static/utils/ubcLog';
import { formatTimeToDate } from '../../pages/qalandpage/utils/util.js';
import TopBar from "../../components/common/topbar.vue";
import { request, getData } from '../../static/utils/request';
import { reqPathTo } from '../../static/utils/env';
import lawRegulationItem from "./components/law-regulation-item.vue";
import searchAnswerItem from "./components/search-answer-item.vue";
import { debounce } from '../../static/utils/core';
import { createCtk } from '../../static/utils/index';
export default {
  components: {
    'top-bar': TopBar,
    'law-regulation-item': lawRegulationItem,
    'search-answer-item': searchAnswerItem
  },
  data() {
    return {
      // 检索数量
      searchNum: 0,
      // 页面内容类型
      tabs: ['法律法规', '法律问答'],
      // tab idx
      tabSelectedIdx: 0,
      // 是否正在检索
      isSearching: true,
      // 搜索推荐列表
      tips: [],
      // 当前总条数
      pn: 0,
      // 每次拉取条数
      rn: 10,
      // 输入框内容
      comment: '',
      // 搜索结果列表
      searchResult: [],
      total: 0,
      // 搜索关键字
      inputVal: '',
      entireHeight: 64,
      // 是否向底部滚动一定距离
      isScrollToBottom: false,
      isSwan: "h5" === 'swan'
    };
  },
  methods: {
    /**
     * tab点击
     */
    selectTab(index) {
      if (this.tabSelectedIdx === index) {
        return;
      }
      this.tabSelectedIdx = index;
      this.total = 0;
      this.clickSearchBtn();
    },
    getEntireHeight() {
      this.entireHeight = 44;
    },
    /**
     * 输入查询
     */
    handleInput(e) {
      const inputContent = e.detail.value.replace(/(^\s*)|(\s*$)/g, '');
      if (inputContent) {
        this.fetchRecList(inputContent);
        this.isSearching = true;
      } else {
        this.tips = [];
      }
      this.inputVal = inputContent;
    },
    /**
     * 清空查询
     */
    clearInput() {
      this.inputVal = '';
      this.tips = [];
      this.searchResult = [];
      this.isSearching = true;
    },
    /**
     * 查询点击
     */
    clickSearchBtn() {
      this.search(this.inputVal, true);
    },
    /**
     * 点击相似问题推荐列表
     * @param {tip} string html代码片段
     */
    clickSimilarQuestion(tip = '') {
      tip = tip.replace(/<span style="font-weight: normal;">/g, '').replace(/<\/span>/g, '');
      this.inputVal = tip;
      this.search(tip, true);
    },
    /**
     * 查询结果
     */
    fetchRecList(inputContent) {
      const url = {
        '0': 'lawregulationsearch',
        '1': 'lawsearch'
      }[this.tabSelectedIdx];
      if (!url) {
        return;
      }
      request({
        url: reqPathTo(url, {}, '', 'swan/ajax'),
        data: {
          query: inputContent || '',
          type: 'sug',
          rn: 5,
          pn: 0
        }
      }).then(res => {
        let {
          data
        } = res.data || {};
        if (!data) {
          return;
        }
        let list = data.list || [];
        list = list.map(e => {
          return this.replaceRedWord(e, 'font');
        });
        this.tips = list;
      }).catch(() => {});
    },
    // 内容标签转换 指定颜色
    replaceRedWord(source, type) {
      if (typeof source !== 'string') {
        return '';
      }
      return source.replace(/<em>/g, `<span style="${type && {
        'font': 'font-weight: normal;',
        'color': 'color: #eb3333;'
      }[type]}">`).replace(/<\/em>/g, '</span>');
    },
    /**
     * 内容处理 去掉br
     * @param {string} text 内容
     */
    replaceContent(text) {
      if (typeof text !== 'string') {
        return '';
      }
      return text.replace(/(<br>|<br\/>|<br \/>)/g, '<br />').replace(/(<br \/>|<br \/><br \/>|<br \/><br \/><br \/>)/g, '');
    },
    /**
     * 搜索
     */
    search(content, reset) {
      if (reset) {
        this.pn = 0;
        this.searchResult = [];
      }
      const {
        tabs,
        tabSelectedIdx,
        searchResult,
        pn,
        rn
      } = this;
      const url = {
        '0': 'lawregulationsearch',
        '1': 'lawsearch'
      }[this.tabSelectedIdx];
      if (!url) {
        return;
      }
      request({
        url: reqPathTo(url, {}, '', 'swan/ajax'),
        data: {
          query: content,
          type: 'search',
          rn,
          pn
        }
      }).then(res => {
        let info = res.data || {};
        if (info.errno !== 0 || !info.data) {
          return;
        }
        let list = info.data.list || [];
        list.forEach(e => {
          e.title = this.replaceRedWord(e.title, this.tabSelectedIdx === 1 ? 'color' : '');
          e.content = this.replaceContent(e.content);
          e.implementTime && (e.formatImplementTime = formatTimeToDate(e.implementTime));
          e.issueTime && (e.formatIssueTime = formatTimeToDate(e.issueTime));
        });
        this.searchResult = searchResult.concat(list);
        this.total = info.data.total || 0;
        this.isSearching = false;
        this.pn = pn + list.length;
        if (!list.length && !this.searchResult.length) {
          this.$api.showToast({
            title: '暂无匹配结果',
            icon: 'none'
          });
        }
      }).catch(() => {
        this.isSearching = false;
      });
    },
    /**
     * 滚动加载更多
     */
    fetchMore() {
      this.search(this.inputVal, false);
    },
    /**
     * 滚动监听
     */
    scroll(e) {
      const curTop = e && e.detail && e.detail.scrollTop;
      let flag = curTop > 100;
      if (this.isScrollToBottom !== flag) {
        this.isScrollToBottom = flag;
      }
    }
  },
  created() {
    (function (query) {
      let {
        type = 0
      } = query;
      this.tabSelectedIdx = +type;
      this.handleInput = debounce(this.handleInput, 300);
      this.getEntireHeight();
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.law-search-container {
  display: flex;
  flex-direction: column;
  padding: 0 2.42vw;
  box-sizing: border-box;
}
.law-search-container.swan-container {
  position: relative;
  height: 100vh;
}
.law-search-container.h5-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.law-search-container .qa-srearch-card-top {
  width: 100%;
  height: 0.66rem;
}
.law-search-container .qa-srearch-card-bg-h5 {
  width: 100%;
  height: 2.1rem;
  background: url("https://lvlin-base.cdn.bcebos.com/law/common/page-bg.png") no-repeat;
  background-size: 100% 1.05rem;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
}
.law-search-container .qa-srearch-card-bg {
  width: 100%;
  height: 2.1rem;
  background: url("https://lvlin-base.cdn.bcebos.com/law/common/page-bg.png") no-repeat;
  background-size: 100% 1.62rem;
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
}
.law-search-container .input-box {
  position: relative;
  margin-top: 3.14vw;
  flex-shrink: 0;
  height: 9.18vw;
  display: flex;
  align-items: center;
  padding: 0 3.22vw;
  background: #f5f6f9;
  border-radius: 8.05vw;
  font-size: 3.86vw;
  line-height: 3.86vw;
}
.law-search-container .input-box .search-icon {
  width: 3.38vw;
  height: 3.38vw;
  background-size: 100% 100%;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/s-search-icon.png');
}
.law-search-container .input-box .input {
  margin: 0 2.42vw;
  flex: 1;
  height: 4.43vw;
  font-size: 4.35vw;
  line-height: 4.43vw;
  background: #f5f6f9;
  outline: none;
  border: 0;
}
.law-search-container .input-box .placeholder {
  font-size: 3.86vw;
}
.law-search-container .input-box .clear-box {
  width: 3.54vw;
  height: 3.54vw;
  background-size: 100% 100%;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/close-icon.png');
}
.law-search-container .input-box .split {
  width: 0.16vw;
  height: 2.9vw;
  background: #e0e0e0;
  margin: 0 2.66vw 0 2.9vw;
}
.law-search-container .input-box .search-btn {
  font-family: PingFangSC-Regular;
  color: #666;
}
.law-search-container.searched .input-box {
  border: 0.16vw solid #ccc;
  box-sizing: border-box;
}
.law-search-container.searched .input-box,
.law-search-container.searched .input {
  background: #fff;
}
.law-search-container .tab-box {
  position: relative;
  margin: 6.44vw 1.69vw 0;
  display: flex;
  align-items: center;
  border-bottom: 0.16vw solid #edeef0;
}
.law-search-container .tab-box .tab-item {
  position: relative;
  font-family: PingFangSC-Medium;
  font-size: 4.11vw;
  color: #50525c;
  text-align: center;
  line-height: 4.11vw;
  padding-bottom: 3.14vw;
  font-weight: 700;
}
.law-search-container .tab-box .tab-item:not(:first-child) {
  margin-left: 9.66vw;
}
.law-search-container .tab-box .tab-item.tab-active {
  color: #1e1f24;
}
.law-search-container .tab-box .tab-item.tab-active::after {
  content: '';
  position: absolute;
  width: 7.81vw;
  height: 0.97vw;
  background: #4e6ef2;
  border-radius: 0.48vw;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
}
.law-search-container .main-content-box {
  position: relative;
  flex: 1;
  height: 100%;
  overflow: hidden;
  padding: 0 1.69vw;
}
.law-search-container .main-content-box .qa-scroll-box {
  width: 100%;
  height: 100%;
}
.law-search-container .main-content-box .search-result-num {
  padding-top: 4.83vw;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #848691;
  line-height: 3.38vw;
}
.law-search-container .main-content-box .search-result-num .blue {
  color: #05f;
}
.law-search-container .search-tip-list-box {
  flex: 1;
  padding: 2.65vw 1.69vw 0;
  overflow-y: auto;
}
.law-search-container .search-tip-list-box .tip-box {
  display: flex;
  align-items: center;
  padding: 3.14vw 0 3.06vw;
  border-bottom: 0.16vw solid #edeef0;
}
.law-search-container .search-tip-list-box .tip-box .search-icon {
  margin-left: 1.69vw;
  flex-shrink: 0;
  width: 3.38vw;
  height: 3.38vw;
  background-size: 100% 100%;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/law-regulation/s-search-icon.png');
}
.law-search-container .search-tip-list-box .tip-box .tip-content {
  width: 0;
  flex: 1;
  padding-left: 3.06vw;
  font-family: PingFangSC-Regular;
  font-size: 4.35vw;
  color: #1e1f24;
  line-height: 4.35vw;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 700;
}

</style>
